import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/Auth";
import Greeting from "../components/Dashboard/Greeting";
import StatsCardRow from "../components/Dashboard/StatsCardRow";
import NextSentenceCard from "../components/Dashboard/NextSentenceCard";
import MyCoursesCard from "../components/Dashboard/MyCoursesCard";
import TeacherHome from "../components/Dashboard/TeacherHome";

function Dashboard() {
    const { t } = useTranslation();
    const { isTeacher } = useAuth();
    const [selectedLanguage, setSelectedLanguage] = useState("de-DE");
    // Bumped whenever a sentence is practiced so the stat cards re-fetch.
    const [statsVersion, setStatsVersion] = useState(0);
    // Teachers land on the teaching view; switching tabs overrides the
    // default for the rest of the session. Students never see the tabs.
    const [manualView, setManualView] = useState(null);
    const view = manualView ?? (isTeacher ? "teaching" : "practice");

    const tabClass = (active) =>
        `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
            active ? "bg-primary text-white" : "text-gray-700 hover:bg-gray-100"
        }`;

    return (
        <div className="px-4 pt-4 md:px-20 md:pt-10 flex flex-col gap-4">
            <Greeting
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
                showLanguageSelect={view === "practice"}
            />

            {isTeacher && (
                <div className="flex gap-1 self-start rounded-lg border border-border bg-secondary p-1">
                    <button
                        className={tabClass(view === "teaching")}
                        onClick={() => setManualView("teaching")}
                    >
                        {t("teach.title")}
                    </button>
                    <button
                        className={tabClass(view === "practice")}
                        onClick={() => setManualView("practice")}
                    >
                        {t("teach.myPractice")}
                    </button>
                </div>
            )}

            {view === "teaching" ? (
                <TeacherHome />
            ) : (
                <>
                    <StatsCardRow
                        selectedLanguage={selectedLanguage}
                        refreshKey={statsVersion}
                    />
                    <NextSentenceCard
                        selectedLanguage={selectedLanguage}
                        onPracticed={() => setStatsVersion((v) => v + 1)}
                    />
                    <MyCoursesCard />
                </>
            )}
        </div>
    );
}

export default Dashboard;
